<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          riders = data
          isLoading = false
        }
      "
      contentId="riders"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Livreurs</div>
      <div>
        <button
          v-if="riders.length > 0"
          @click="addNewRider"
          class="buttonComponent"
        >
          Nouveau livreur
        </button>
      </div>
    </div>
    <div class="py-2"></div>

    <div class="relative" v-if="isLoading || riders.length > 0">
      <div class="overflow-auto">
        <div>
          <div
            class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
          >
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              Livreurs
            </div>

            <div class="flex gap-6 w-[10rem] min-w-[10rem]">Date d'ajout</div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">Total Livré</div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">En cours</div>
            <!-- <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              Dernière livraison
            </div> -->

            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              Actions
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <div
            v-for="(rider, index) in isLoading ? shimmerriders : riders"
            :key="index"
            :class="{ shimmerElement: rider.shimmer }"
            class="flex items-center justify-between p-4 py-2 rounded-2xl gap-8 [&>div]:relative h-[4lh]"
          >
            <div
              class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
            ></div>
            <!-- Product Info -->
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              <img
                :src="rider.image"
                class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-xl"
              />
              <div class="w-[16rem]">
                <h3 class="font-semibold title-color truncate">
                  {{ rider.name }}
                </h3>
                <p class="truncate text-sm">
                  {{ rider.email }}
                </p>
                <p class="truncate text-sm">#{{ rider.id }}</p>
              </div>
            </div>

            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.timestampToDate(rider.createdAt, 'DD MMM YYYY') }}
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.formatAmount(rider.totalDelivered || 0) }}
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.formatAmount(rider.pendingDelivery || 0) }}
            </div>
            <!-- <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.timestampToDate(rider.lastOrder, 'DD MMM YYYY') }}
            </div> -->

            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              <DropdownComponent
                :selects="[
                  {
                    name: 'Retirer',
                    onClick() {
                      deleteRider(rider)
                    },
                  },
                ]"
                hideArrow
                maxHeight="270px"
                displayKey="name"
                toLeft
                :onSelect="
                  selected => {
                    selected.onClick()
                  }
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                </svg>
              </DropdownComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/6">
        <img src="@/assets/images/empty/post-office.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun livreur ajouté.</div>
        <div class="py-1"></div>
        <div class="text-lg">Vos livreurs s'afficheront ici</div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <button @click="addNewRider" class="buttonComponent">
            Ajouter un livreur
          </button>
        </div>
      </div>
    </div>
    <EventListener
      :events="['rider_deleted', 'failed_to_delete_rider']"
      @rider_deleted="onRiderDeleted"
      @failed_to_delete_rider="onRiderDeletionFailed"
    />
    <NewRiderAdding />
  </div>
</template>

<script>
import NewRiderAdding from '@/components/riders/NewRiderAdding.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    EventListener,
    NewRiderAdding,
  },
  data() {
    return {
      eventsIds: [],
      riders: [],
      activeTab: 'home',
      isLoading: true,
      shimmerriders: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewRider() {
      this.$Events.dispatchEvent('rider_creation_requested')
    },
    async deleteRider(rider) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez-vous vraiment retirer le livreur ${rider.email} ?`,
          subTitle: 'Toutes les données concernant ce livreur seront effacé',

          successText: 'Supprimer le livreur',
          cancelText: 'Conserver le livreur',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('rider_deletion_requested', {
        id: rider.id,
      })
    },
    onRiderDeleted() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Réussi',
        body: 'Le livreur a été supprimé avec succès',
      })
    },
    onRiderDeletionFailed(response) {
      let message = 'Echec lors de la supression du livreur'
      if (response.riderNotFound) message = "Ce livreur n'est plus enrégistré"
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echoué',
        body: message,
      })
    },
  },
}
</script>
